import React from 'react';
import ArticuloService from 'src/modules/articulo/articuloService';
import AutocompleteInMemoryFormItem from 'src/view/shared/form/items/AutocompleteInMemoryFormItem';

function buildArticuloLabel(originalValue) {
  const codigo = String(originalValue?.codigoArticulo || '').trim();
  const descripcion = String(originalValue?.descripcion || '').trim();
  if (codigo && descripcion) {
    return `${codigo} — ${descripcion}`;
  }
  return codigo || descripcion || originalValue?.label || '';
}

function ArticuloAutocompleteFormItem(props) {
  const fetchFn = (value, limit) => {
    return ArticuloService.listAutocomplete(value, limit);
  };

  const mapper = {
    toAutocomplete(originalValue) {
      if (!originalValue) {
        return null;
      }

      const value = originalValue.id;
      const label = buildArticuloLabel(originalValue);

      return {
        key: value,
        value,
        label,
      };
    },

    toValue(originalValue) {
      if (!originalValue) {
        return null;
      }

      return {
        id: originalValue.value ?? originalValue.id,
        label: originalValue.label,
        codigoArticulo: originalValue.codigoArticulo ?? null,
        descripcion: originalValue.descripcion ?? null,
        kgBruto: originalValue.kgBruto ?? null,
        rangoClingG: originalValue.rangoClingG ?? null,
        punzLabMm: originalValue.punzLabMm ?? null,
        elongacionMin: originalValue.elongacionMin ?? null,
        codigoPlanta: originalValue.codigoPlanta ?? null,
      };
    },
  };

  return (
    <AutocompleteInMemoryFormItem
      {...props}
      fetchFn={fetchFn}
      noLink
      mapper={mapper}
      hasPermissionToCreate={false}
      showCreate={false}
    />
  );
}

export default ArticuloAutocompleteFormItem;
